// extracted by mini-css-extract-plugin
module.exports = {"no-projects-message":"ProjectList_no-projects-message__kJEq-","top50-projects-list":"ProjectList_top50-projects-list__30ycp"};